import { render, staticRenderFns } from "./ConsultaTuCuentaResult.vue?vue&type=template&id=5fa3f1fe&scoped=true"
import script from "./ConsultaTuCuentaResult.vue?vue&type=script&lang=ts"
export * from "./ConsultaTuCuentaResult.vue?vue&type=script&lang=ts"
import style0 from "./ConsultaTuCuentaResult.vue?vue&type=style&index=0&id=5fa3f1fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa3f1fe",
  null
  
)

export default component.exports